function Work() {
  return (
    <>
      <div id="contact1" className="flex flex-col my-5 box-border px-8 text-white">
        <div className="text-center">
          <h1 className="m-0 text-xl font-bold mb-5">My Work</h1>
        </div>
        <div className="flex flex-col gap-30">
          <div className="flex md:flex-row sm:flex-col items-center justify-evenly lg:mb-10 sm:mb-0">
            <a href="https://calfinity-hire.vercel.app/" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                {/* <img src="linkedin.png" alt="LinkedIn" /> */}
                <h1 className="text-xl font-bold">Calfinity Hire</h1>
              </div>
            </a>
            <a href="https://www.plattebandauto.be/" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                {/* <img src="github.png" alt="GitHub" /> */}
                <h1 className="text-xl font-bold">Help 24</h1>
              </div>
            </a>
          </div>
          <div className="flex md:flex-row sm:flex-col justify-evenly items-center">
            <a href="https://academy-software-upop-bm8a3of5p-wispah.vercel.app/login/" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                {/* <img src="Email.png" alt="Email" /> */}
                <h1 className="text-xl font-bold">Academy Software</h1>
              </div>
            </a>
            <a href="https://www.figma.com/design/vKpITBeL7mgH6TdkHhlaxw/SPA?node-id=0-1&t=yU8DNyoO4MZSHnp0-0" target="_blank" rel="noopener noreferrer">
              <div className="flex flex-col justify-center items-center lg:h-40 sm:h-36  lg:w-96 sm:w-72 bg-gray-800 m-4 rounded-lg">
                {/* <img src="whatsapp.png" alt="WhatsApp" /> */}
                <h1 className="text-xl font-bold">Spa Management System</h1>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default Work;
